<template>
    <v-dialog v-model="dialog" persistent>
        <template #activator="{on}">
            <v-btn v-on="on">Check country config</v-btn>
        </template>
        <v-card :loading="loading" :disabled="loading">
            <v-card-title>Country Check</v-card-title>
            <v-card-text>
                <template v-if="!country">
                    <Country v-model="country" label="Country"/>
                </template>
                <template v-else>
                    <v-row>
                        <v-col>
                            <h3>{{ selectedCountry.name }}</h3>
                            <v-btn small @click="country=null">reset</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h3>Associated accounts</h3>
                            <v-row>
                                <v-col>Global Sales</v-col>
                                <v-col>{{ hasLink('sales') ? 'linked' : 'not linked' }}</v-col>
                                <v-col><AccountTree v-model="accounts.sales" @change="saveAccount('sales', $event)" /></v-col>
                            </v-row>
                            <v-row>
                                <v-col>Product Sales</v-col>
                                <v-col>{{ hasLink('product') ? 'linked' : 'not linked' }}</v-col>
                                <v-col><AccountTree v-model="accounts.product" @change="saveAccount('product', $event)" /></v-col>
                            </v-row>
                            <v-row>
                                <v-col>Shipping</v-col>
                                <v-col>{{ hasLink('shipping') ? 'linked' : 'not linked' }}</v-col>
                                <v-col><AccountTree v-model="accounts.shipping" @change="saveAccount('shipping', $event)" /></v-col>
                            </v-row>
                            <v-row>
                                <v-col>Fitting</v-col>
                                <v-col>{{ hasLink('fitting') ? 'linked' : 'not linked' }}</v-col>
                                <v-col><AccountTree v-model="accounts.fitting" @change="saveAccount('fitting', $event)" /></v-col>
                            </v-row>
                            <v-row>
                                <v-col>Puring</v-col>
                                <v-col>{{ hasLink('puring') ? 'linked' : 'not linked' }}</v-col>
                                <v-col><AccountTree v-model="accounts.puring" @change="saveAccount('puring', $event)" /></v-col>
                            </v-row>
                            <v-row>
                                <v-col>Service</v-col>
                                <v-col>{{ hasLink('service') ? 'linked' : 'not linked' }}</v-col>
                                <v-col><AccountTree v-model="accounts.service" @change="saveAccount('service', $event)" /></v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h3>Tax</h3>
                            <v-row v-for="tax in tax_rates" :key="tax.name">
                                <v-col>{{ tax.name }} ({{ tax.taxRate }}%)</v-col>
                                <v-col>{{ tax.bexio_id ? 'linked' : 'not linked' }}</v-col>
                                <v-col>
                                    <TaxRateForm :rate="tax" @change="getCountryInfos">
                                        <template #activator="{ on }">
                                            <v-btn v-on="on">
                                                Change
                                            </v-btn>
                                        </template>
                                    </TaxRateForm>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="close">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { countries } from '../../utils/country';
import { mapActions } from 'vuex';
import Country from '../forms/autocomplete/Country.vue';
import AccountTree from './form/AccountTree.vue';
import TaxRateForm from '../../components/taxrates/form.vue'

export default {
    name: "BexioCountryCheck",
    components: { Country, AccountTree, TaxRateForm },
    data: () => ({
        dialog: false,
        country: null,
        loading: false,
        links: [],
        tax_rates: [],
        accounts: {}
    }),
    computed: {
        selectedCountry () {
            return countries.find(c => c.code == this.country)
        },
        
    },
    watch: {
        country (c) {
            if(c){
                this.getCountryInfos()
            }
        }
    },
    methods: {
        ...mapActions('bexioLink', ['getByGroup', 'createLink']),
        ...mapActions('taxRates',{ getTaxes: 'index', updateTax: 'update'}),
        getCountryInfos () {
            this.loading = true
            Promise.all([
                this.getByGroup(this.country),
                this.getTaxes({filter:{ country: this.country}})
            ]).then(([{links}, {tax_rates}]) => {
                this.dispatchLinks(links)
                this.tax_rates = tax_rates.data
            }).finally(() => {
                this.loading = false
            })
        },
        dispatchLinks(links){
            this.links = links

            this.accounts = {
                sales: this.hasLink('sales') ? this.hasLink('sales').bexio_id : null,
                product: this.hasLink('product') ? this.hasLink('product').bexio_id : null,
                shipping: this.hasLink('shipping') ? this.hasLink('shipping').bexio_id : null,
                fitting: this.hasLink('fitting') ? this.hasLink('fitting').bexio_id : null,
                puring: this.hasLink('puring') ? this.hasLink('puring').bexio_id : null,
                service: this.hasLink('service') ? this.hasLink('service').bexio_id : null,
            }
        },
        close () {
            this.dialog = false
            this.country = null
            this.links = []
            this.tax_rates = []
        },
        hasLink(type) {
            return this.links.find(l => l.type==type)
        },
        saveAccount(type, account) {
            this.createLink({
                group: this.country,
                type,
                bexio_id: account
            }).then(({links}) => {
                this.dispatchLinks(links)
            })
        },
        saveTaxLink(tax) {
            this.updateTax(tax)
                .then(({links}) => {
                    this.dispatchLinks(links)
                })
        }
    }
}
</script>